import api from './client';
import { API_ENDPOINTS } from './endpoints';

export type ArCategoryAction = 'RESOLVED' | 'FUTURE FOLLOW UP' | 'NEED ASSISTANCE';
export type ArCategoryStatus = 'NON-EXCEPTION' | 'EXCEPTIONS';

export interface ArSubCategoryApiItem {
  _id?: string;
  sub_category: string;
  action: ArCategoryAction;
  status: ArCategoryStatus;
}

export interface ArCategoryApiItem {
  _id: string;
  category: string;
  sub_categories: ArSubCategoryApiItem[];
  meta?: { status?: string };
  createdAt?: string;
  updatedAt?: string;
}

export interface ArCategoriesListResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data?: {
    categories?: ArCategoryApiItem[];
    count?: number;
  } | ArCategoryApiItem[];
}

export interface UpsertArCategoryPayload {
  id?: string;
  category: string;
  sub_categories: Array<{
    sub_category: string;
    action: ArCategoryAction;
    status: ArCategoryStatus;
  }>;
}

export interface ArCategoryMutationResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data?: ArCategoryApiItem | null;
}

export const getArCategories = async (params?: {
  page?: number;
  limit?: number;
  search?: string;
}): Promise<ArCategoriesListResponse> => {
  return api.get<ArCategoriesListResponse>(API_ENDPOINTS.arCategories.list, { params });
};

export const upsertArCategory = async (
  payload: UpsertArCategoryPayload,
): Promise<ArCategoryMutationResponse> => {
  return api.post<ArCategoryMutationResponse, UpsertArCategoryPayload>(
    API_ENDPOINTS.arCategories.upsert,
    payload,
  );
};

export const deleteArCategory = async (id: string): Promise<ArCategoryMutationResponse> => {
  return api.delete<ArCategoryMutationResponse>(
    `${API_ENDPOINTS.arCategories.list}/${id}`,
  );
};
